import React,{useState} from 'react'
import {useSelector, useDispatch} from 'react-redux';
import { FaHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './style.css';
import currencyFormatter from 'currency-formatter'
import Tippy from '@tippy.js/react';
import'tippy.js/dist/tippy.css';

import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure()

const Products = () => {

    const dispatch = useDispatch()
       
    const {products,dealDay,newProducts} = useSelector(state => state.allprodcuts);
    
    const [type, setType] = useState('');
    const [sort, setSort] = useState('');
    const [size, setSize] = useState('');
    const [pro, setPro] = useState([...newProducts]);

    
    const handelType = (e) => {
        setType(e.target.value)
       if(e.target.value ==="all"){
           setPro(newProducts)
       }else{
        setPro(newProducts.filter(item => item.title === e.target.value))
       }
    }

   const handleSize = (e) => {
       const mainSize = e.target.value
        setSize(mainSize)
        if(e.target.value === ""){
            setSize(e.target.value)
            setPro([])
        }
        else if(e.target.value ==="all"){
            setPro(newProducts)
        }
        else{
            setSize(e.target.value)
            setPro(newProducts.filter(item => item.suitableSize.indexOf(e.target.value)>=0))
        }
    }

    const handleSort = (e) => {
        const sort = e.target.value
        setSort(sort)
        setPro(pre => pre.slice().sort((a,b) => 
        sort ==="lowest"?
        a.price > b.price?1:-1:
        sort === "heightest"?
        a.price <b.price ?1:-1:
        a.id<b.id
        ))
    }

   
    /*   notification   */
    const fav = () => {
        toast.success("The Product have been added to favourite",{
            position:toast.POSITION.TOP_CENTER
        })
    }

    const cart = () => {
        toast.success("The Product have been added to cart",{
            position:toast.POSITION.TOP_CENTER
        })
    }



   
    return (
        <div className="allProducts">
            <div className="section-title">
                <h2>our products</h2>
            </div>
        <div className="products">
            <div className="container">
                <div className="row">
                    {
                        products.map(product => (
                            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" key={product.id}>
                                <div className="product-content">
                                    <div className="product-fav">
                                        
                                        {product.discount? <span className="discount">{product.discount} %</span>: ""}
                                        
                                        <span className="heart"><FaHeart /></span>
                                    </div>

                                    <div className="product-img">
                                        <div className="circle">
                                            <img src={product.image} alt={product.title} />
                                        </div>
                                    </div>

                                    <h5>{product.title}</h5>
                                    <div className="product-price">
                                    <p>{product.discount?<span className="price">{currencyFormatter.format(product.price, { code: 'USD' })}</span>:currencyFormatter.format(product.price, { code: 'USD' })}</p>
                                    <p className="discount">{product.discount? `${product.discount} %`: ""}</p>
                                    <p className="discountPrice">{product.discountPrice ?currencyFormatter.format(product.discountPrice, { code: 'USD' }):""}</p>
                                    </div>
                                    <div className="product-icons">
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star-half"></i>
                                       
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>

            {/* ========   new products  ================ */}

            <div>
                <div className="newProducts">
            <div className="section-title">
                <h2>New products</h2>
            </div>

            <div className="container">
            <div className="filter-items">
                <div>
                    <span>Products</span>
                    <form>
                    <select name="cars"
                       value={type}
                       onChange={handelType}
                     className="custom-select custom-select-sm"
        
                     >
                        <option value="all">All</option>
                        <option value="Jacket">Jackets</option>
                        <option value="Suit">Suits</option>
                        <option value="Shoes">Shoes</option>
                        <option value="bag">Bages</option>
                        <option value="Dress">Dresses</option>
                        <option value="T-shirt">T-shirts</option>
                    </select>
                    </form>
                </div>

                <div>
                    <span>Sort </span>
                    <form>
                    <select name="cars" 
                    className="custom-select custom-select-sm"
                    value={sort}
                    onChange={handleSort}
                    >
                       
                        <option >Latest</option>
                        <option value="lowest">Lowest</option>
                        <option value="heightest">Heightest</option>
                        
                    </select>
                    </form>
                </div>

                <div>
                    <span>Size</span>
                    <form>
                    <select name="cars"
                    value={size}
                    onChange={handleSize}
                     className="custom-select custom-select-sm"
                     
                      >
                        <option value="all">All</option>
                        <option value="large">Large</option>
                        <option value="meduim">Medium</option>
                        <option value="small">Small</option>
                        <option value="xLarge">X large</option>
                        <option value="2xLarge">2X large</option>
                    </select>
                    </form>
                </div>
                </div>

            <div className="row">
                {
                    pro.map(newProduct => (
                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" key={newProduct.id}>
                            <div className="new-content">
                                <div className="new-content-img">
                                    <div className="layer">
                                        <div>
                                            <Tippy content={<span style={{color:"#fff"}}>Details</span>}>
                                              <Link to={`/details/${newProduct.id}`}> <div><i className="fa fa-eye"></i></div></Link>
                                            </Tippy>
                                        </div>

                                        <div>
                                            <Tippy content={<span style={{color:"#fff"}}>Add To Favourite</span>}>
                                            
                                            <div onClick={() => {
                                                 dispatch({type:'ADD_FAV', payload:newProduct})
                                                 fav()
                                                }}
                                                 ><i className="fa fa-heart"></i></div>
                                            
                                            </Tippy>
                                        </div>

                                        <div>
                                            <Tippy content={<span style={{color:"#fff"}}>Add To Cart</span>}>
                                               <div onClick={()=>{
                                                 dispatch({type:'ADD_NEW_PROD',payload:newProduct})
                                                 cart() 
                                                }
                                                 }><i className="fa fa-shopping-cart"></i></div>
                                            </Tippy>
                                        </div>
                                    </div>
                                    <img src={newProduct.image} alt={newProduct.title} />
                                </div>

                                <div className="product-icons">
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>
                                        <i className="fa fa-star"></i>            
                                    </div>

                                <h5>{newProduct.title}</h5>
                                <p>{currencyFormatter.format(newProduct.price, { code: 'USD' })}</p>
                                </div>
                        </div>
                    ))
                }
                  </div>
                </div>
            </div>
        </div>

            {/* =========================
                    deal of the day
            =============================*/}

            <div className="section-title">
                <h2>deal of the day</h2>
            </div>

            <div className="deal">
                <div className="container">
                    <div className="row">
                        {
                            dealDay.map(item => (
                                <div className="col-md-6 col-sm-12" key={item.id}>
                                    <div className="deal-content">
                                        <div className="deal-img">
                                            <img src={item.image} alt={item.title} />
                                        </div>

                                        <div className="deal-desc">
                                            <h5>{item.title}</h5>
                                            <span className="deal-price">{currencyFormatter.format(item.price, { code: 'USD' })}</span>
                                            <p>{item.desc}</p>
                                            <div className="product-icons">
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="far fa-star"></i>           
                                            </div>

                                            <button onClick={() =>
                                                { dispatch({type:"ADD_DEAL_PROD",payload:item})
                                                cart()}
                                            }><i className="fa fa-shopping-cart"></i>Add to cart</button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>  
    )
}

export default Products

